/* =============================================================================
   Cherry Tuning — shared behaviour for all .cy components.
   Loaded once site-wide from layout/theme.liquid (defer).
   - .cy-rv  : reveal-on-scroll (respects reduced-motion)
   - .cy-acc : accordion group — opening one <details> closes its siblings
   Re-runs on shopify:section:load so it works in the theme editor too.
   ============================================================================= */
(function(){
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealIn(scope){
    var items = [].slice.call((scope || document).querySelectorAll('.cy-rv:not(.in)'));
    if(!items.length) return;
    if(REDUCED || !('IntersectionObserver' in window)){
      items.forEach(function(el){ el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -7% 0px' });
    items.forEach(function(el, i){ el.style.transitionDelay = ((i % 5) * 40) + 'ms'; io.observe(el); });
  }

  function wireAccordions(scope){
    [].slice.call((scope || document).querySelectorAll('.cy-acc')).forEach(function(group){
      if(group.dataset.cyAcc) return;            // don't double-wire
      group.dataset.cyAcc = '1';
      var items = [].slice.call(group.querySelectorAll('details'));
      items.forEach(function(d){
        d.addEventListener('toggle', function(){
          if(d.open){ items.forEach(function(o){ if(o !== d) o.open = false; }); }
        });
      });
    });
  }

  function init(scope){ revealIn(scope); wireAccordions(scope); }

  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', function(){ init(document); }); }
  else { init(document); }

  // Theme editor: a section just got (re)loaded — wire only that section.
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();

/* ---- Cherry wishlist (localStorage, no backend required) ---- */
(function(){
  var KEY = 'cyWishlist';
  function read(){ try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch(e){ return {}; } }
  function write(o){ try { localStorage.setItem(KEY, JSON.stringify(o)); } catch(e){} bump(); }
  function bump(){ var n = Object.keys(read()).length; [].slice.call(document.querySelectorAll('[data-cy-wishlist-count]')).forEach(function(el){ el.textContent = n; el.style.display = n ? '' : 'none'; }); }
  function heartSvg(){ return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-8-5.2-10-9.5C.6 8 2.3 4.5 6 4.5c2 0 3.2 1 4 2.2.8-1.2 2-2.2 4-2.2 3.7 0 5.4 3.5 4 7-2 4.3-10 9.5-10 9.5z"/></svg>'; }
  function markHearts(scope){ var w = read(); [].slice.call((scope || document).querySelectorAll('.cy-heart[data-id]')).forEach(function(b){ var on = !!w[b.getAttribute('data-id')]; b.classList.toggle('is-saved', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); }); }
  function toggle(btn){
    var id = btn.getAttribute('data-id'); if(!id) return; var w = read();
    if(w[id]){ delete w[id]; } else { w[id] = { handle: btn.getAttribute('data-handle'), title: btn.getAttribute('data-title'), image: btn.getAttribute('data-image'), price: btn.getAttribute('data-price'), url: btn.getAttribute('data-url') }; }
    write(w); markHearts(document); renderWL();
  }
  function esc(s){ return (s || '').replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function renderWL(){
    var root = document.getElementById('cy-wishlist-root'); if(!root) return;
    var w = read(), ids = Object.keys(w);
    if(!ids.length){ root.innerHTML = '<div class="cy-wl-empty"><p class="cy-h3" style="margin-bottom:8px">Your wishlist is empty</p><p>Tap the heart on any product or car to save it here.</p></div>'; return; }
    var html = '<div class="cy-wl-grid">';
    ids.forEach(function(id){ var it = w[id];
      html += '<div class="cy-wl-card"><button class="cy-heart is-saved cy-wl-rm" data-id="' + esc(id) + '" title="Remove" aria-label="Remove from wishlist">' + heartSvg() + '</button>'
        + '<a class="cy-wl-img" href="' + esc(it.url || '#') + '">' + (it.image ? '<img src="' + esc(it.image) + '" alt="' + esc(it.title) + '" loading="lazy">' : '') + '</a>'
        + '<div class="cy-wl-bd"><a class="cy-wl-t" href="' + esc(it.url || '#') + '" style="text-decoration:none">' + esc(it.title) + '</a>'
        + (it.price ? '<div class="cy-wl-pr">' + esc(it.price) + '</div>' : '') + '</div></div>';
    });
    html += '</div>'; root.innerHTML = html; markHearts(root);
  }
  document.addEventListener('click', function(e){ var b = e.target.closest && e.target.closest('.cy-heart'); if(b){ e.preventDefault(); toggle(b); } });
  function wlInit(){ markHearts(document); bump(); renderWL(); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', wlInit); } else { wlInit(); }
  document.addEventListener('shopify:section:load', function(e){ markHearts(e.target); renderWL(); });
})();
